import pricingData from '../pricing-data.json';
import type { PricingAddon, PricingAddonName } from '../types/pricingApiTypes';
import type { MentoringPlan, MentoringPlanKey } from '../types';
import { formatToman } from './index';

const mentoringPlansMeta = [...pricingData.addons.mentoring.plans].sort(
  (first, second) => first.order - second.order,
);

const TRACKER_ADDON_NAMES: PricingAddonName[] = ['tracker', 'trcaker'];
const WALLET_ADDON_NAME: PricingAddonName = 'wallet';

export const MENTORING_PLAN_KEY = 'seo_360' as const satisfies MentoringPlanKey;

const MENTORING_ADDON_NAMES: Record<MentoringPlanKey, PricingAddonName> = {
  seo_360: 'mentoring_seo_360',
};

function findAddonByName(
  addons: PricingAddon[],
  name: PricingAddonName,
): PricingAddon | undefined {
  return addons.find((addon) => addon.name === name);
}

export function getTrackerAddon(
  addons: PricingAddon[],
): PricingAddon | undefined {
  return addons.find((addon) =>
    TRACKER_ADDON_NAMES.includes(addon.name as PricingAddonName),
  );
}

export function getTrackerDailyPrice(addons: PricingAddon[]): number {
  return getTrackerAddon(addons)?.price ?? 0;
}

export function getTrackerAddonId(addons: PricingAddon[]): string | undefined {
  return getTrackerAddon(addons)?.id;
}

export function getWalletAddon(
  addons: PricingAddon[],
): PricingAddon | undefined {
  return findAddonByName(addons, WALLET_ADDON_NAME);
}

export function getWalletAddonId(addons: PricingAddon[]): string | undefined {
  return getWalletAddon(addons)?.id;
}

export function buildMentoringPlansWithPrices(
  addons: PricingAddon[],
): MentoringPlan[] {
  return mentoringPlansMeta.map((plan) => {
    const addon = findAddonByName(addons, MENTORING_ADDON_NAMES[plan.key]);
    const price = addon?.price ?? 0;

    return {
      ...plan,
      price,
      priceLabel: formatToman(price),
      addonId: addon?.id,
    };
  });
}
